import React from 'react';
import { Button } from '@mui/material';
import PropTypes from 'prop-types';

const SecondaryButton = React.forwardRef(({
  children,
  onClick,
  disabled = false,
  fullWidth = false,
  size = 'medium',
  startIcon,
  endIcon,
  ...props
}, ref) => {
  return (
  <Button
      ref={ref}
      variant="outlined"
      onClick={onClick}
      disabled={disabled}
      fullWidth={fullWidth}
      size={size}
      startIcon={startIcon}
      endIcon={endIcon}
      sx={{
        borderColor: 'var(--primary)',
        color: 'var(--primary)',
        fontWeight: 500,
        textTransform: 'none',
        borderRadius: 2,
        '&:hover': {
          borderColor: 'var(--primary)',
          backgroundColor: 'var(--primary-light)'
        },
        '&:active': {
          transform: 'scale(0.98)'
        },
        '&:disabled': {
          opacity: 0.6,
          cursor: 'not-allowed'
        },
        transition: 'all 0.3s ease',
        ...props.sx
      }}
      {...props}
    >
      {children}
    </Button>
  );
});

SecondaryButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  startIcon: PropTypes.node,
  endIcon: PropTypes.node,
  sx: PropTypes.object
};

export default SecondaryButton;